import {
  BUYER_OUTREACH,
  BuyerOutreach,
  MEDIA_PACKAGE,
  MediaPackage,
} from 'models/Listing';
import { transformPriceNumberToCurrencyString } from 'utils';
import { BUYER_OUTREACH_PRICES, MEDIA_PACKAGE_PRICES } from 'data/prices';
import { AddonCardOption } from '../components/AddonCard/AddonCard.component';
import CalendarIcon from 'icons/Calendar.icon';
import ChatIcon from 'icons/Chat.icon';
import ChecklistIcon from 'icons/Checklist.icon';
import TargetIcon from 'icons/Target.icon';
import { SelectCardOption } from '../components/SelectCard/SelectCard.component';

export const BUYER_OUTREACH_DATA: Record<BuyerOutreach, SelectCardOption> = {
  [BUYER_OUTREACH.TWO_WEEKS]: {
    title: 'two-weeks-outreach_title',
    price: transformPriceNumberToCurrencyString(
      BUYER_OUTREACH_PRICES[BUYER_OUTREACH.TWO_WEEKS],
    ),
    list: ['two-weeks-outreach_perk_1', 'two-weeks-outreach_perk_2'],
  },
  [BUYER_OUTREACH.FOUR_WEEKS]: {
    title: 'four-weeks-outreach_title',
    price: transformPriceNumberToCurrencyString(
      BUYER_OUTREACH_PRICES[BUYER_OUTREACH.FOUR_WEEKS],
    ),
    list: [
      'four-weeks-outreach_perk_1',
      'four-weeks-outreach_perk_2',
      'four-weeks-outreach_perk_3',
    ],
  },
};

export const MEDIA_PACKAGE_DATA: Record<MediaPackage, AddonCardOption> = {
  [MEDIA_PACKAGE.TRIED_AND_TESTED]: {
    title: 'tried_and_tested_title',
    price: transformPriceNumberToCurrencyString(
      MEDIA_PACKAGE_PRICES[MEDIA_PACKAGE.TRIED_AND_TESTED],
    ),
    list: ['tried_and_tested_perk_1', 'tried_and_tested_perk_2'],
  },
  [MEDIA_PACKAGE.TARGETED]: {
    title: 'targeted_title',
    price: transformPriceNumberToCurrencyString(
      MEDIA_PACKAGE_PRICES[MEDIA_PACKAGE.TARGETED],
    ),
    list: ['targeted_perk_1', 'targeted_perk_2'],
  },
  [MEDIA_PACKAGE.PRINT_PACKAGE]: {
    title: 'print-package_title',
    price: transformPriceNumberToCurrencyString(
      MEDIA_PACKAGE_PRICES[MEDIA_PACKAGE.PRINT_PACKAGE],
    ),
    list: [
      'print-package_perk_1',
      'print-package_perk_2',
      'print-package_perk_3',
    ],
  },
  [MEDIA_PACKAGE.THE_WORKS]: {
    title: 'the-works_title',
    price: transformPriceNumberToCurrencyString(
      MEDIA_PACKAGE_PRICES[MEDIA_PACKAGE.THE_WORKS],
    ),
    list: [
      'the-works_perk_1',
      'the-works_perk_2',
      'the-works_perk_3',
      'the-works_perk_4',
    ],
  },
};

export const TILES = [
  {
    description: 'twoBuyerOutreachPackages_d1',
    Icon: CalendarIcon,
  },
  {
    description: 'twoBuyerOutreachPackages_d2',
    Icon: ChatIcon,
  },
  {
    description: 'twoBuyerOutreachPackages_d3',
    Icon: ChecklistIcon,
  },
  {
    description: 'twoBuyerOutreachPackages_d4',
    Icon: TargetIcon,
  },
];
